// extracted by mini-css-extract-plugin
export var dataCell = "_ot-2";
export var dataRow = "_ot-0";
export var headerRow = "_ot-1";